export default __webpack_public_path__ + "static/media/hl2.1fa1c933.jpeg";